import { render, staticRenderFns } from "./UpdatePrices.vue?vue&type=template&id=4c88b79d&scoped=true"
import script from "./UpdatePrices.vue?vue&type=script&lang=js"
export * from "./UpdatePrices.vue?vue&type=script&lang=js"
import style0 from "./UpdatePrices.vue?vue&type=style&index=0&id=4c88b79d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88b79d",
  null
  
)

export default component.exports